import { Tag } from 'antd';

const DefaultViewTag = () => (
    <Tag className="!m-0 !inline-flex !w-fit !items-center !justify-center !rounded !border !border-[#d9d9d9] !bg-[rgba(0,0,0,0.02)] !px-2 !py-px !text-[12px] !font-normal !leading-[20px] !text-[rgba(0,0,0,0.88)]">
        Default
    </Tag>
);

export default DefaultViewTag;
